import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useProductFlag } from '@/hooks/useProductFlag'

export const LIVE_HERO_FLAG = 'homepage-live-hero'

/** `VITE_HOMEPAGE_LIVE_HERO=0` is a build-time kill switch; anything else defers to runtime. */
export function liveHeroKilled(value = import.meta.env.VITE_HOMEPAGE_LIVE_HERO) {
  return value?.trim() === '0'
}

/**
 * Whether the homepage offers "Try it live".
 * On with the PostHog flag `homepage-live-hero` or the `?hero=live` review
 * override, unless the build-time kill switch is set.
 */
export function useLiveHeroEnabled() {
  const { search } = useLocation()
  const flag = useProductFlag(LIVE_HERO_FLAG)
  const override = useMemo(() => new URLSearchParams(search).get('hero') === 'live', [search])
  if (liveHeroKilled()) return false
  return override || flag === true
}
